import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { globalData } from '../data/general-objects';
import { Trending } from '../models/trending';
import { AuthenticationServiceService } from './authentication-service.service';

@Injectable({
    providedIn: 'root'
})
export class TrendingService {

    private url: string = globalData.restBaseUrl + "/trending/last/";
    
    constructor(private http: HttpClient,
        private authService: AuthenticationServiceService,) { }

    getLastValue(device: number, variable: string, startDate: string, endDate: string): Observable<Trending> {
        if (!this.authService.isUserLoggedIn) {
            return null;
        }

        let endpoint: string = this.url + "device/" + device + "/variable/" + variable
            + "?startDate=" + startDate + "&endDate=" + endDate;

        return this.http.get<Trending>(`${endpoint}`, this.authService.getStandardHeader());
    }
}
